import { store } from '../store'

const dispatch = store.dispatch as any

const dispatchCreateFolder = ({ currentFolderName, currentFolderDescription, currentembeddingModel, currentVectorDatabase }: any) =>
  dispatch.contentModel.createFolderEffect({ currentFolderName, currentFolderDescription, currentembeddingModel, currentVectorDatabase })
const dispatchUpdateCurrentFolder = (folderDetail: any) =>
  dispatch.contentModel.updateCurrentFolder(folderDetail)
const dispatchListFolders = (type: string) => dispatch.contentModel.listFoldersEffect(type)
const dispatchTempListFolders = (type: string) => dispatch.contentModel.listTempFoldersEffect(type)
const dispatchClearChatMessage = () => dispatch.contentModel.clearChatMessage()

const dispatchDeleteFolder = ({ folderId, type }: any) =>
  dispatch.contentModel.deleteFolderEffect({ folderId, type })
const dispatchUpdateFolder = ({ payload, type }: any) =>
  dispatch.contentModel.updateFolderEffect({ payload, type })
const dispatchListFiles = (folderId: string) => dispatch.contentModel.listFilesEffect(folderId)
const dispatchFetchStatusCount = (folderId: string) => dispatch.contentModel.fetchStatusCountEffect(folderId)
const dispatchUploadRetryFiles = (payload: any) => dispatch.contentModel.uploadRetryFilesEffect(payload)
const dispatchUpdateFile = ({ file_id, file_name, file_tags }: any) =>
  dispatch.contentModel.updateFileEffect({ file_id, file_name, file_tags })
const dispatchDeleteFile = (payload: any) => dispatch.contentModel.deleteFile(payload)
const dispatchTemplates = () => dispatch.contentModel.listPromptTemplates()
const dispatchPromptPublished = () =>
  dispatch.contentModel.listPublishedPrompts()
const dispatchPromptDraft = () =>
  dispatch.contentModel.listDraftPrompts()
const dispatchUploadFile = ({ file_names, folder_id, tags, type, action }: any) =>
  dispatch.contentModel.uploadFile({ file_names, folder_id, tags, type, action })
const dispatchManagePrompt = (payload: any) => dispatch.contentModel.managePrompts(payload)
const dispatchManagePromptApp = (payload: any) => dispatch.contentModel.managePromptsApp(payload)

const dispatchAddComments = (payload: any) => dispatch.contentModel.addComments(payload)
const dispatchAddCommentsApp = (payload: any) => dispatch.contentModel.addCommentsApp(payload)
const dispatchPromptHistory = (promptId: string) =>
  dispatch.contentModel.listPromptHistory(promptId)
const dispatchPublishPrompt = (id?: any) => dispatch.contentModel.publishPromptDraft(id)
const dispatchUnpublishPrompt = (id?: any) => dispatch.contentModel.unpublishPromptPublished(id)
const disaptchPromptTest = (payload: any) => dispatch.contentModel.promptTestChat(payload)
const dispatchChatMessage = (payload: any) => dispatch.contentModel.updateChatMessage(payload)
const dispatchLLMModels = () => dispatch.contentModel.LLModelList()
const dispatchLLMModelsForSettings = () => dispatch.contentModel.LLModelListForSettings()
const dispatchCreateLlmConfig = (payload: any) => dispatch.contentModel.createLlmConfig(payload)
const dispatchUpdateLlmConfig = (payload: any) => dispatch.contentModel.updateLlmConfig(payload)
const dispatchDeleteLlmConfig = (id: string) => dispatch.contentModel.deleteLlmConfig(id)
const dispatchVectorDb = () => dispatch.contentModel.getVectorDb()

const dispatchGetPromptDetails = (promptId: string) => {
  dispatch.contentModel.getPromptDetails({ promptId })
}
const dispatchGetPromptTemplateDetails = (promptId: string) => {
  dispatch.contentModel.getPromptTemplateDetails({ promptId })
}

const dispatchPromptData = (payload: any) => dispatch.contentModel.updatePromptData(payload)
const dispatchAppData = () => dispatch.contentModel.listAppTemplates()
const dispatchAppPublished = () =>
  dispatch.contentModel.listAppPublished()
const dispatchAppDraft = () =>
  dispatch.contentModel.listAppDraft()

const dispatchClearChat = () => dispatch.contentModel.clearChatMessage()
const dispatchClearBulkRunStatusdynamic = () => dispatch.contentModel.clearBulkRunStatusDynamic()
const dispatchCreateApp = (payload: any) => dispatch.contentModel.createApp(payload)
const dispatchCreateAppNewtab = (payload: any) => dispatch.contentModel.createAppNewtab(payload)
const dispatchUpdateApp = (payload: any) => dispatch.contentModel.updateApp(payload)
const dispatchSaveCurrentAppDetails = (payload: any) =>
  dispatch.contentModel.updateCurrentAppDetails(payload)
const dispatchAppToolTest = (payload: any) => dispatch.contentModel.appToolTest(payload)
const dispatchDeleteApp = (appId: string) => dispatch.contentModel.deleteApp(appId)
const dispatchValidateDeletion = (appId: string) => dispatch.contentModel.validateDeletion(appId)
const dispatchAppDetails = (appId: any) => {
  dispatch.contentModel.getAppDetails({ appId })
}
const dispatchPublishedAppEditDetails = (appId: any, type: any) => {
  dispatch.contentModel.getPublishedAppEditDetails({ appId, type })
}
const dispatchAppDetailsTemplates = (appId: any) => {
  dispatch.contentModel.getAppDetailsTemplate({ appId })
}

const dispatchAppShareDetails = (appId: any) => {
  dispatch.contentModel.getAppShareDetails({ appId })
}

const dispatchQueryUrls = (url: any) => {
  dispatch.contentModel.stopGeneration(url)
}
const dispatchUpdateQueryUrlWithRequest = (payload: any) => dispatch.contentModel.updateQueryUrlWithRequest(payload)
const dispatchPublishApp = (payload: any) => dispatch.contentModel.publishApp(payload)
const dispatchAppHistory = (appId: any, payload: any, pagination?: any) => dispatch.contentModel.listAppHistory({ appId, payload, pagination })
const dispatchAppVersions = (appId: string, type: string, isTemplate: boolean) => dispatch.contentModel.listAppVersions({ appId, type, isTemplate })
const dispatchGetRunStatus = (appId: string, execId: any, appname: any, type: any) => dispatch.contentModel.getBulkTestStatus({ appId, execId, appname, type })
const dispatchAppShareToolTest = (payload: any, appId: any) => dispatch.contentModel.appToolShareTest({ payload, appId })
const dispatchRunHistory = (appId: any, payload: any, pagination?: any) => dispatch.contentModel.listRunHistory({ appId, payload, pagination })
const dispatchTags = () => dispatch.contentModel.listTags()
//const dispatchPromptTags = () =>  dispatch.contentModel.listPromptTags()
const dispatchAppShareLinkGeneration = (payload: any) => dispatch.contentModel.appShareLinkGeneration(payload)
const dispatchAppShareLinkValidation = (payload: any) => dispatch.contentModel.appShareLinkValidation(payload)
const dispatchbulkrunStatusApp = (payload: any) => dispatch.contentModel.bulkrunStatusApp(payload)
const dispatchEvalsRunStatus = (payload: any) => dispatch.contentModel.evalsRunStatus(payload)
const dispatchGetEvalDatasets = (type: string, agent_id: string) => dispatch.contentModel.getEvalDatasets({ type, agent_id })
const dispatchGetEvalHistory = (type: string, agent_id: string) => dispatch.contentModel.getEvalHistory({ type, agent_id })
const dispatchRunEvalAgent = (payload: { agent_id: string; dataset_name: string }) => dispatch.contentModel.runEvalAgent(payload)
const dispatchRunEvalApp = (payload: { app_id: string; dataset_name: string; id: string; dataset_id: string }) => dispatch.contentModel.runEvalApp(payload)
const dispatchCreateEvalDataset = (payload: { name: string; app_id?: string; agent_id?: string }) => dispatch.contentModel.createEvalDataset(payload)
const dispatchExportWorkflow = (appId: string) => dispatch.contentModel.exportWorkflow(appId)
const dispatchImportWorkflow = (payload: any) => dispatch.contentModel.importWorkflow(payload)
const dispatcVisionMModels = () => dispatch.contentModel.VisionModalList()
const dispatchVoiceModels = () => dispatch.contentModel.VoiceModelList()
const dispatchModels = () => dispatch.contentModel.getModels()

const dispatchUploadFileConfluence = (payload: any) => dispatch.contentModel.uploadFilesConfluence(payload)
const dispatchUploadFileSharePoint = (payload: any) => dispatch.contentModel.uploadFilesSharePoint(payload)
const dispatchUploadFileSlack = (payload: any) => dispatch.contentModel.uploadFilesSlack(payload)
const dispatchUploadFileSlackChannels = (payload: any) => dispatch.contentModel.uploadFilesSlackChannels(payload)
const dispatchUploadFileUsingLink = (payload: any) => dispatch.contentModel.uploadFilesusingLink(payload)
const dispatchUploadFilesInternal = (payload: any) => dispatch.contentModel.uploadFilesInternal(payload)
const dispatchUploadInAppShare = (payload: any) => dispatch.contentModel.dispatchUploadInAppShare(payload)

const dispatchFileUploadMultiplePaths = (fileInfo: any, name: any, appIds: any) => dispatch.contentModel.uploadFileMultipleApps({ fileInfo, name, appIds })

const dispatchenduserapi = (payload: any) => dispatch.contentModel.enduserapi(payload)

const dispatchgenerateFileUpload = (payload: any, metadata: any, isGoogleDrive: boolean) => dispatch.contentModel.generateSAStoken({ payload, metadata, isGoogleDrive })
const dispatchDownloadBulkrunTemplate = (payload: any, app_name: any) => dispatch.contentModel.generateSAStokenToDownloadTemplate({ payload, app_name })
const dispatchDownloadBulkrunTemplateAiAgent = (payload: any, app_name: any) => dispatch.contentModel.generateSAStokenToDownloadTemplateAiAgent({ payload, app_name })
const dispatchTerminateBulkrun = (payload: any) => dispatch.contentModel.terminateBulkrun(payload)
const dispatchTerminateBulkrunforAutoSolve = (url: any) => dispatch.contentModel.terminateBulkrunforAutoSolve(url)
const dispatchExecuteBulkRun = (payload: any) => dispatch.contentModel.executeBulkrun(payload)
const dispatchAppApiIntegrate = (payload: any) => dispatch.contentModel.appApiIntegrate(payload)
const dispatchEnableDisableUser = (payload: any) => dispatch.contentModel.enableDisableUser(payload)
const dispatchListUsers = (type: any) => dispatch.contentModel.listUsers(type)
const dispatchEmailInvite = (payload: any) => dispatch.contentModel.emailInvite(payload)
const dispatchUpdateUserDetails = (payload: any) => dispatch.contentModel.updateUserDetails(payload)
const dispatchCreateUser = (payload: any) => dispatch.contentModel.createUser(payload)
const dispatchDeleteUser = (userId: any) => dispatch.contentModel.deleteUser(userId)
const dispatchGetUserDetails = (userId: any) => dispatch.contentModel.getUserDetails(userId)
const dispatchListTenants = (opts?: { skipContentLoading?: boolean }) =>
  dispatch.contentModel.getTenantList(opts)
const dispatchCreateTenants = (payload: any) => dispatch.contentModel.createTenants(payload)
const dispatchUpdateTenants = (payload: any) => dispatch.contentModel.updateTenants(payload)
const dispatchClearUserList = () => dispatch.contentModel.updateUserList()
const dispatchAccessList = () => dispatch.contentModel.getAccessList()
const dispatchWorkspaceAccess = (payload: any) => dispatch.contentModel.getWorkspaceAccess(payload)
const dispatchRolesList = () => dispatch.contentModel.getRoleList()
const dispatchDeleteAccess = (accessId: any) => dispatch.contentModel.deleteAccess(accessId)
const dispatchCreateRole = (payload: any) => dispatch.contentModel.createRole(payload)
const dispatchUpdateRole = (payload: any) => dispatch.contentModel.updateRole(payload)
const dispatchDeleteRole = (roleId: any) => dispatch.contentModel.deleteRole(roleId)
const dispatchTenantDetails = () => dispatch.contentModel.getTenanatDetails()
const dispatchSetPermissionValues = (idToken: string) => dispatch.contentModel.setPermissionValues(idToken)
const dispatchPackageList = () => dispatch.contentModel.getPackageList()
const dispatchProuctsList = (opts?: { skipContentLoading?: boolean }) =>
  dispatch.contentModel.getProductList(opts)
const dispatchUpdateProduct = (payload: any) => dispatch.contentModel.updateProduct(payload)
const dispatchCreatePackage = (payload: any) => dispatch.contentModel.createPackage(payload)
const dispatchUpdatePackage = (payload: any) => dispatch.contentModel.updatePackages(payload)
const dispatchDeletePackages = (packageId: any) => dispatch.contentModel.deletePackage(packageId)
const dispatchDeleteTenants = (Id: any) => dispatch.contentModel.deleteTenants(Id)
const dispatchDisableTenants = (Id: any) => dispatch.contentModel.disableTenant(Id)
const dispatchupdateUserView = (payload: any) => dispatch.contentModel.updateViewUser(payload)
const dispatchEnableTenants = (Id: any) => dispatch.contentModel.enableTenant(Id)
const dispatchIntegrationList = () => dispatch.contentModel.getIntegrationList()
const dispatchMasterIntegrationList = () => dispatch.contentModel.getMasterTenantIntegrations()
const dispatchDeletIntegration = (integrationId: any) => dispatch.contentModel.deleteIntegration(integrationId)
const dispatchUpdateIntegration = (payload: any) => dispatch.contentModel.updateIntegration(payload)
const dispatchCreateIntegration = (payload: any) => dispatch.contentModel.createIntegration(payload)
const dispatchListAppForPackages = () => dispatch.contentModel.listAppForPackage()
const dispatchListAppGeneral = () => dispatch.contentModel.listAppGeneral()
const dispatchSetAsDefault = (payload: any) => dispatch.contentModel.setAsDefault(payload)
const dispatchFeatureSettings = () => dispatch.contentModel.getFeatureSettings()
const dispatchAutosolveDashboard = (payload: any) => dispatch.contentModel.getAutosolveDashboard(payload)
const dispatchHomeDashboardTotal = (payload: any) => dispatch.contentModel.getHomeDashboardTotal(payload)
const dispatchHomeDashboardAgentAssist = (payload: any) => dispatch.contentModel.getAgentAssistDashboard(payload)
const dispatchHomeDashboardWorkflow = (payload: any) => dispatch.contentModel.getWorkflowDashboard(payload)
const diaptchUpdateFileUploadStatus = (fileToReplace: any) => dispatch.contentModel.updateUploadedFileValues(fileToReplace)
const dispatchUpdateFeatureSettingsStatus = (payload: any) => dispatch.contentModel.updateFetaureSettingsStatus(payload)
const dispatchCreateFeatureIntegrationSettings = (payload: any) => dispatch.contentModel.createFeatureIntegrationSettings(payload)
const dispatchCloneAutoSolveFeature = (payload: any) => dispatch.contentModel.cloneAutosolveFeature(payload)
const dispatchCreateFeatureIntegrationSettingsAutoSolve = (data: any) => dispatch.contentModel.createFeatureIntegrationSettingsAutoSolve(data)
const dispatchCreateFolderGroup = (payload: any, type: any) => dispatch.contentModel.createGroupFolder({ payload, type })
const dispatchSetAsTemplate = (payload: any) => dispatch.contentModel.setAsTemplate(payload)
const dispatchTicketDetails = (payload: any) => dispatch.contentModel.updateTicketDetail(payload)
const dispatchListAutoTags = (type: any) => dispatch.contentModel.getAutoTagList(type)
const dispatchUpdateTicketType = (payload: any, type: any) => dispatch.contentModel.updateTicketType({ payload, type })
const dispatchCompanyInfo = (payload: any) => dispatch.contentModel.updateCompanyInfo(payload)
const dispatchUpdatePersona = (payload: any) => dispatch.contentModel.updatePersona(payload)
const dispatchGetFeatureAppDetails = (appId: any) => dispatch.contentModel.getFeatureAppDetails(appId)
const dispatchGetPackageDetails = (type: any) => dispatch.contentModel.getPacakageDetails(type)
const dispatchGetAppId = (appId: any) => dispatch.contentModel.getAppId(appId)
const dispatchUpdateFeatureSettings = (payload: any) => dispatch.contentModel.editFeatureSettings(payload)
const dispatchGetEndPointUrl = (payload: any) => dispatch.contentModel.getEndPointUrl(payload)
const dispatchGetTenantGroups = (Id: any) => dispatch.contentModel.getTenantGroups(Id)
const dispatchSaveTenantGroups = (payload: any) => dispatch.contentModel.saveTenantGroups(payload)
const dispatchCreateFodlerFaqPt = (payload: any) => dispatch.contentModel.createFolderFaqPT(payload)
const dispatchListUserRows = (type: any, folderId: any) => dispatch.contentModel.getGroupRowDetails({ type, folderId })
const dispatchDeleteRowDetails = (type: any, rowId: any) => dispatch.contentModel.deleteGroupRowDetails({ type, rowId })
const dispatchDeleteFaqPastTicketGroups = (type: any, folderId: any) => dispatch.contentModel.deleteGroupsFaqPastTickets({ type, folderId })
const dispatchGetIntegrationToolsForTenants = () => dispatch.contentModel.getIntegrationToolsForTenant()
const dispatchGetIntegrationForTools = (tool: any) => dispatch.contentModel.getIntegrationsForSelectedTool(tool)
const dispatchEmbeddingModelList = () => dispatch.contentModel.embeddingModelList()
const dispatchCxAutosolveFilter = () => dispatch.contentModel.getCxAutosolveFilter()
const dispatchCxAutosolveDownload = (payload: any) => dispatch.contentModel.getCxAutosolveDownload(payload)
const dispatchCxAgentAssistFilter = () => dispatch.contentModel.getCxAgentAssistFilter()
const dispatchCxAgentAssistCardDetails = (payload: any) => dispatch.contentModel.getCxAgentAssistCardDetails(payload)
const dispatchCxAgentAssistDownload = (payload: any) => dispatch.contentModel.getCxAgentAssistDownload(payload)
const dispatchCxAutosolveFourCards = (payload: any) => dispatch.contentModel.getCxAutosolveFourCards(payload)
const dispatchImportPastTickets = (payload: any) => dispatch.contentModel.importPastTickets(payload)

const dispatchTopIntentsQuery = (payload: any) => dispatch.contentModel.topIntentsQuery(payload)
const dispatchTopIncreasedIntenetQuery = (payload: any) => dispatch.contentModel.topIncreasedIntenetQuery(payload)
const dispatchTopDecreasedIntentQuery = (payload: any) => dispatch.contentModel.topDecreasedIntentQuery(payload)
const dispatchTotalIntentsCountQuery = (payload: any) => dispatch.contentModel.totalIntentsCountQuery(payload)
const dispatchTicketBasedOnIntent = (payload: any) => dispatch.contentModel.ticketsBasedonIntent(payload)
const dispatchIntentsGrpahData = (payload: any) => dispatch.contentModel.IntentsGraphData(payload)
const dispatchIntentsList = (payload: any) => dispatch.contentModel.IntentsLists(payload)
const dispatchTimetoResponse = (payload: any) => dispatch.contentModel.TimeToResponse(payload)
const dispatchTimetoResolve = (payload: any) => dispatch.contentModel.TimeToResolve(payload)
const dispatchTicketEscallation = (payload: any) => dispatch.contentModel.TicketEscallation(payload)
const dispatchFirstContactResolution = (payload: any) => dispatch.contentModel.FirstContactResolution(payload)
const dispatchCommonTags = (payload: any) => dispatch.contentModel.CommonTags(payload)

const dispatchSubscriptionDetails = () => dispatch.contentModel.getSubscriptionDetails()
const dispatchUpdateTelemetry = (payload: any) => dispatch.contentModel.updateTelemetry(payload)
const dispatchCurrentModule = (payload: any) => dispatch.contentModel.updateCurrentModule(payload)
const dispatchDeleteTicketsFaqPt = (rowId: any, type: any) => dispatch.contentModel.deleteTicketsFaqPt({ rowId, type })
const dispatchCustomerHealthDetails = (customer: any) => dispatch.contentModel.updateCustomerHealth(customer)
const dispatchTestChatBot = (payload: any) => dispatch.contentModel.testChatBot(payload)
const dispatchTestChatBotAdithyaBirla = (payload: any) => dispatch.contentModel.testChatBotAdithyaBirla(payload)
const dispatchClearChatBotHistory = () => dispatch.contentModel.clearChatBotHistory()
const dispatchChatMessageState = (payload: any) => dispatch.contentModel.updateChatMessageState(payload)
const dispatchListAllIntents = (payload: any) => dispatch.contentModel.listAllIntents(payload)
const dispatchFiltervalues = (payload: any) => dispatch.contentModel.controlroomFilerValues(payload)
const dispatchAppInsights = (payload: any, appType: any) => dispatch.contentModel.appInsights({ payload, appType })

const dispatchBotDetails = (payload: any) => dispatch.contentModel.getBotDetails(payload)
const dispatchClearBotDetails = () => dispatch.contentModel.clearChatDetails()
const dispatchUpdateBot = (payload: any, type?: any, showupdate?: boolean) => dispatch.contentModel.updateBot({ payload, type, showupdate })
const dispatchAutoSolveBot = ({ payload, errorMessage }: any) => dispatch.contentModel.testAutoSolveBot({ payload, errorMessage })
const dispatchListWidgets = () => dispatch.contentModel.listWidgets()
//const dispatchgetWidgetHistoryDetails = ()=> dispatch.contentModel.getWidgetHistoryDetails()
const dispatchGetWidgetTypes = () => dispatch.contentModel.listWidgetTypes()
const dispatchCreateWidget = (payload: any) => dispatch.contentModel.createWidget(payload)
const dispatchUpdateWidget = (payload: any) => dispatch.contentModel.updateWidget(payload)
const dispatchTestWidget = (payload: any) => dispatch.contentModel.testWidget(payload)
const dispatchGetMcpTools = (payload: any) => dispatch.contentModel.getMcpTools(payload)
const dispatchGetAgentList = (payload: any) => dispatch.contentModel.getAgentList(payload)
const dispatchGetAgentVersions = (agent_id: any) => dispatch.contentModel.getAgentVersions(agent_id)
const dispatchGetDefaultAgent = (agent_id: any) => dispatch.contentModel.getDefaultAgent(agent_id)
const dispatchSetAgentDefault = (payload: any) => dispatch.contentModel.setAgentDefault(payload)
const dispatchPublishAgent = (payload: any) => dispatch.contentModel.publishAgent(payload)
const dispatchGetInstallationList = () => dispatch.contentModel.getInstallationList()
const dispatchUpdateSelectedTools = (payload: any) => dispatch.contentModel.updateSelectedTools(payload)
const dispatchCreateAgent = (payload: any) => dispatch.contentModel.createAgent(payload)
const dispatchCreateBot = (payload: any) => dispatch.contentModel.createBot(payload)
const dispatchUpdateAgent = (payload: any, supervisor_data?: any) => dispatch.contentModel.updateAgentValues({ payload, supervisor_data })
const dispatchUpdateAgentValuesToNull = () => dispatch.contentModel.updateAgent(null)
const dispatchDeleteAgent = (payload: any) => dispatch.contentModel.deleteAgent(payload)
const dispatchDeleteWidget = (payload: any) => dispatch.contentModel.deleteWidget(payload)
const dispatchGetWidgetDetails = (payload: any) => dispatch.contentModel.getWidgetDetails(payload)
const dispatchgetWidgetHistoryDetails = (payload: any, tool_id: any) => dispatch.contentModel.getWidgetHistoryDetails({ payload, tool_id })
const dispatchClearWidgetDetails = () => dispatch.contentModel.updateWidgetDetails({})
const dispatchSetWidgetDetails = (payload: any) => dispatch.contentModel.updateWidgetDetails(payload)
const dispatchClearAgentDetails = () => dispatch.contentModel.updateAgent({})
const dispatchClearAgentVersions = () => dispatch.contentModel.updateAgentVersions([])
const dispatchGetBotRunHistory = (payload: any) => dispatch.contentModel.getBotRunHistory(payload)
const dispatchGetBotRunHistoryOfConversation = (payload: any) => dispatch.contentModel.getBotRunHistoryofConversation(payload)
const dispatchUpdateChatdetailsToEmpty = (payload: any) => dispatch.contentModel.updateAutosolveRunHistoryDetailsOfConversation(payload)
const dispatchAgentConversationList = (payload: any, filter?: boolean, isfeedback?: boolean, initial?: any) => dispatch.contentModel.getAgentConversationList({ payload, filter, isfeedback, initial })
const dispatchGetAgentConversationDetails = (payload: any) => dispatch.contentModel.getAgentAssistConversationDetail(payload)
const dispatchlistScheduler = (payload: any, filter?: boolean) => dispatch.contentModel.getlistScheduler({ payload, filter })
const dispatchUpdateAgentChatdetailsToEmpty = (payload: any) => dispatch.contentModel.updateAgentConversationDetail(payload)
const dispatchGetAgentAssistFilterDetails = () => dispatch.contentModel.getAgentAssistFilterDetails()
const dispatchGenerateCode = (payload: any) => dispatch.contentModel.generateCode(payload)
const dispatchBotTestHistory = (bot_id: any, id: any, headers: any) => {
  dispatch.contentModel.getBotTestHistoryWebFormat({ bot_id, id, headers })
}
const dispatchSaveFeedback = (payload: any, user_id: any, headers: any) => dispatch.contentModel.saveFeedback({ payload, user_id, headers })
const dispatchTestApp = (appPayload: any, headers: any) => dispatch.contentModel.testApp({ appPayload, headers });
const dispatchGetAutosolveConversation = (payload: any, filter?: boolean, isfeedback?: boolean) => dispatch.contentModel.getAutosolveConversationDetail({ payload, filter, isfeedback })
const dispatchClearFileParams = (payload: any) => dispatch.contentModel.clearFileParams(payload)
const dispatchClearApiWidget = () => dispatch.contentModel.clearWidgetDetails()
const dispatchClearTotalConversationCount = () => dispatch.contentModel.clearTotalConversationCount()
const dispatchClearTotalUpvoteCount = () => dispatch.contentModel.clearTotalUpvoteCount()
const dispatchClearTotalDownvoteCount = () => dispatch.contentModel.clearTotalDownvoteCount()
const dispatchClearTotalUpvoteCountAgentAssist = () => dispatch.contentModel.clearTotalUpvoteCountAgentAssist()
const dispatchClearTotalDownvoteCountAgentAssist = () => dispatch.contentModel.clearTotalDownvoteCountAgentAssist()
const dispatchClearTotalConversationCountAgentAssist = () => dispatch.contentModel.clearTotalConversationCountAgentAssist()



const dispatchAutoSolveFeedBack = (payload: any) => dispatch.contentModel.saveFeedbackAutoSolve(payload)
const dispatchGenerateSASTokenForDownload = (payload: any, name: any) => dispatch.contentModel.generateSASTokenForFileDownload({ payload, name })
const dispatchClearFileUrl = (payload: any) => dispatch.contentModel.updateFileUrl('')
const dispatchAutoSolveMetaData = () => dispatch.contentModel.getAutosolveMetaData()
const dispatchDownloadCsvReport = (payload: any) => dispatch.contentModel.downloadCsvReport(payload)
const dispatchDownloadCsvReportAgentAssist = (payload: any) => dispatch.contentModel.downloadCsvReportAgentAssist(payload)
const dispatchExportAutosolve = (botId: any, agentName: any) => dispatch.contentModel.exportAutosolve({ botId, agentName })
const dispatchImportAutosolve = (payload: any, flag: any) => dispatch.contentModel.importAutosolve({ payload, flag })
const dispatchGenerateSASTokenGeneric = (payload: any) => dispatch.contentModel.generateSASTokenGeneric(payload)
const dispatchGetUserMappedRoles = (role: any) => dispatch.contentModel.getUserMappedRoles(role)
const dispatchCreateScheduler = (payload: any) => dispatch.contentModel.getcreateScheduler(payload)
const dispatchGetMasterData = () => dispatch.contentModel.getMasterData()
const dispatchCloneAutosolveFeature = (payload: any) => dispatch.contentModel.cloneAutosolveFeature(payload)
const dispatchUpdateFetaureSettings = (payload: any) => dispatch.contentModel.updateFetaureSettings(payload)
const dispatchCreateAutoSolveFeature = (payload: any) => dispatch.contentModel.createAutoSolveFeature(payload)
// const dispatchPinotQuery = (payload:any) => dispatch.contentModel.pinotQuery(payload)
const dispatchNaturalLanguageQueryTranslation = (payload: any) => dispatch.contentModel.naturalLanguageQueryTranslation(payload)
const dispatchClearAgentList = () => dispatch.contentModel.clearAgentList()
const dispatchGetBlockLevelHistory = (instanceId: any) => dispatch.contentModel.getBlockLevelHistory(instanceId)
const dispatchClearBlockLevelHistory = () => dispatch.contentModel.updateBlockLevelHistory([])
const dispatchClearQueryUrl = () => dispatch.contentModel.updateQueryUrl({})
const dispatchValidateChannel = (payload: any, channelType: any) => dispatch.contentModel.validateChannel({ payload, channelType })
const dispatchDeleteScheduler = (schedulerId: any) => dispatch.contentModel.deleteSchedulerEffect(schedulerId)
const dispatchUpdateScheduler = (payload: any) => dispatch.contentModel.updateScheduler(payload)
const dispatchGetSchedulerHistory = (schedulerId: any, payload: any) => dispatch.contentModel.getSchedulerHistory({ schedulerId, payload })
const dispatchControlRoomDiscoverScreenSaveFilter = (payload: any) => dispatch.contentModel.controlRoomDiscoverScreenSaveFilter(payload)
const dispatchGetControlRoomDiscoverScreenSavedFilterNames = (payload: any) => dispatch.contentModel.getControlRoomDiscoverScreenSavedFilterNames(payload)
const dispatchGetControlRoomDiscoverScreenSavedFilterDetails = (payload: any) => dispatch.contentModel.getControlRoomDiscoverScreenSavedFilterDetails(payload)
const dispatchGetControlRoomDiscoverScreenDelete = (payload: any) => dispatch.contentModel.getControlRoomDiscoverScreenDelete(payload)
const dispatchControlRoomDynamicQuery = (payload: any) => dispatch.contentModel.controlRoomDynamicQuery(payload)
const dispatchGetControlRoomDiscoverScreenGetColumns = () => dispatch.contentModel.getControlRoomDiscoverScreenGetColumns()
const dispatchGetControlRoomDiscoverScreenGetColumnValuesForFilter = (payload: any) => dispatch.contentModel.getControlRoomDiscoverScreenGetColumnValuesForFilter(payload)
const dispatchGetControlRoomFilterList = (payload: any) => dispatch.contentModel.getControlRoomFilterList(payload)
const dispatchGetOrganizationSummaryDriverFilter = () => dispatch.contentModel.getOrganizationSummaryDriverFilter()
const dispatchGetSupersetCustomDashboardList = () => dispatch.contentModel.getSupersetCustomDashboardList()
const dispatchUpdateCustomField = (payload: any) => dispatch.contentModel.updateCustomField(payload)
const dispatchGetAgentDetails = (agent_id: any) => dispatch.contentModel.getAgentDetails(agent_id)
const dispatchGetAutoSolveBlockLevelHistory = (bot_id: any, conversation_id: any) => dispatch.contentModel.getAutoSolveBlockLevelHistory({ bot_id, conversation_id })
const dispatchGetllmModelDetailsForAutoSolve = () => dispatch.contentModel.getllmModelDetailsForAutoSolve()
const dispatchFileuploadBulkrun = (payload: any) => dispatch.contentModel.fileuploadBulkrun(payload)
const dispatchAutosolverunbatch = (payload: any) => dispatch.contentModel.autosolverunbatch(payload)
const dispatchBotWidgetObjectDetails = (bot_key: any) => dispatch.contentModel.getwidgetObjectDetails(bot_key)
const dispatchGetActiveEnterPriseHubList = () => dispatch.contentModel.getActiveEnterPriseHubList()
const dispatchUpdateEnterPriseHubList = (payload: any) => dispatch.contentModel.updateEnterPriseHubList(payload)
const dispatchGetExHubHistory = (payload: any) => dispatch.contentModel.getExHubHistory(payload)
const dispatchAutosolveTestHistory = (botId: any, payload: any) => dispatch.contentModel.getAutosolveTestHistory({ botId, payload })
const dispatchSupersetCredentials = () => dispatch.contentModel.supersetCredentials()
const dispatchSupersetLogin = (payload: any): any => dispatch.contentModel.supersetLogin(payload)
const dispatchSupersetCsrfToken = (payload: any) => dispatch.contentModel.supersetCsrfToken()
const dispatchGetSupersetChartAPI = (chartId: any, headers: any) => dispatch.contentModel.getSupersetChartAPI({ chartId, headers })
const dispatchGetSupersetChartData = (payload: any) => dispatch.contentModel.getSupersetChartData(payload)
const dispatchGetSupersetChartID = () => dispatch.contentModel.getSupersetChartID()
const dispatchGetSupersetUrl = () => dispatch.contentModel.getSupersetUrl()
const dispatchGetRealTimeAudio = () => dispatch.contentModel.getRealTimeAudio()
const dispatchcustomerInteractionAutosolveHistory = (payload: any) => dispatch.contentModel.getcustomerInteractionAutosolveHistory(payload)

const dispatchSingleConversationData = (payload: any) => dispatch.contentModel.getSingleConversationData(payload)
const dispatchLiveAgentNotifications = (payload: any) => dispatch.contentModel.getLiveAgentNotifications(payload)
const dispatchLiveAgentEndCall = (payload: any) => dispatch.contentModel.LiveAgentEndCall(payload)
const dispatchcustomerInteractionAgentAssistHistory = (payload: any) => dispatch.contentModel.getcustomerInteractionAgentAssistHistory(payload)
const dispatchSingleAgentAssistConversation = (payload: any) => dispatch.contentModel.getSingleAgentAssistConversationData(payload)
const dispatchupdateactiveliveagent = (payload: any) => dispatch.contentModel.updateactiveliveagent(payload)
const dispatchremoveactiveliveagent = (payload: any) => dispatch.contentModel.removeactiveliveagent(payload)

// Seeker dispatch functions
const dispatchCxSeekerCards = (payload: any) => dispatch.contentModel.getCxSeekerCards(payload)
const dispatchCxSeekerHistoryList = (payload: any) => dispatch.contentModel.getCxSeekerHistoryList(payload)
const dispatchCxSeekerDownload = (payload: any) => dispatch.contentModel.downloadCxSeekerCsv(payload)
const dispatchCxSeekerFeedback = (payload: any) => dispatch.contentModel.updateCxSeekerFeedback(payload)
const dispatchCxSeekerConversationDetails = (payload: any) => dispatch.contentModel.getCxSeekerConversationDetails(payload)
const dispatchExecuteSeekerPinotQuery = (payload: any) => dispatch.contentModel.executeSeekerPinotQuery(payload)
const dispatchGetAlertsForControlRoom = (payload: any) => dispatch.contentModel.getAlertsForControlRoom(payload)
const dispatchGetReportsForControlRoom = (payload: any) => dispatch.contentModel.getReportsForControlRoom(payload)
const dispatchAddNewReports = (payload: any) => dispatch.contentModel.addNewReports(payload)
const dispatchGetColumnValuesForFilter = (payload: any) => dispatch.contentModel.getColumnValues(payload)
const dispatchGetAlertDetails = (payload: any) => dispatch.contentModel.getAlertDetails(payload)
const dispatchCreateAlert = (payload: any) => dispatch.contentModel.createAlert(payload)
const dispatchUpdateAlert = (payload: any) => dispatch.contentModel.updateAlert(payload)
const dispatchDeleteAlert = (payload: any) => dispatch.contentModel.deleteAlert(payload)
const dispatchDeleteReport = (report_id: any) => dispatch.contentModel.deleteReport(report_id)

const dispatchGetTrustforteList = () => dispatch.contentModel.getTrustforteList()

const dispatchGetAgentsList = () => dispatch.contentModel.getAgentLists()
const dispatchGetLatestPublishedApp = (appId: any) => dispatch.contentModel.getLatestPublishedApp(appId)

const dispatchGetTrustforteMailDocumentData = (id: any) => dispatch.contentModel.getTrustforteMailDocumentData(id)
const dispatchUpdateAppDetails = (payload: any) => dispatch.contentModel.updateAppDetails(payload)

const dispatchGetDatabaseList = (payload: { integration_key: string }) => dispatch.contentModel.getDatabaseListEffect(payload)
const dispatchGetDatabaseSchemas = (payload: { integration_key: string; display_name: string }) => dispatch.contentModel.getDatabaseSchemasEffect(payload)
const dispatchGetDatabaseTables = (payload: { integration_key: string; display_name: string; schema: string }) => dispatch.contentModel.getDatabaseTablesEffect(payload)
const dispatchGetDatabaseColumns = (payload: { integration_key: string; display_name: string; schema: string; table: string }) => dispatch.contentModel.getDatabaseColumnsEffect(payload)
const dispatchSaveIntegrations = (payload: {
  integration_key: string;
  status: string;
  ssl: string;
  config_data: Array<{
    key_name: string;
    display_name: string;
    payload_key: string;
    value: string;
  }>;
  integration_display_name: string;
  display_name: string;
}) => dispatch.contentModel.saveIntegrationsEffect(payload)

const dispatchUpdateDatabaseBlock = (payload: {
  data: {
    label: string;
    config: {
      databse_id: string;
      query: string;
    };
  };
  type: string;
}) => dispatch.contentModel.updateDatabaseBlockEffect(payload)

const dispatchUpdateScheduleStatus = (payload: any) => dispatch.contentModel.updateScheduleStatusEffect(payload)

const dispatchDownloadPdfApi = (payload: any) => dispatch.contentModel.downloadPdfApi(payload)

const dispatchGetTemplateList = (payload: any) => dispatch.contentModel.getTemplateList(payload)
const dispatchFetchTemplateDetails = (payload: any) => dispatch.contentModel.fetchTemplateDetails(payload)
const dispatchUploadTemplate = (payload: any) => dispatch.contentModel.uploadTemplate(payload)
const dispatchDeleteTemplate = (folderId: any, initiated_by: any, id: any) => dispatch.contentModel.deleteTemplate({ folderId, initiated_by, id })

export {
  dispatchCreateFolder,
  dispatchUpdateCurrentFolder,
  dispatchListFolders,
  dispatchTempListFolders,
  dispatchClearChatMessage,
  dispatchDeleteFolder,
  dispatchUpdateFolder,
  dispatchListFiles,
  dispatchFetchStatusCount,
  dispatchUploadRetryFiles,
  dispatchUpdateFile,
  dispatchDeleteFile,
  dispatchTemplates,
  dispatchAppPublished,
  dispatchUploadFile,
  dispatchManagePrompt,
  dispatchAddComments,
  dispatchPromptHistory,
  dispatchPublishPrompt,
  dispatchUnpublishPrompt,
  disaptchPromptTest,
  dispatchChatMessage,
  dispatchLLMModels,
  dispatchLLMModelsForSettings,
  dispatchCreateLlmConfig,
  dispatchUpdateLlmConfig,
  dispatchDeleteLlmConfig,
  dispatchGetPromptDetails,
  dispatchPromptData,
  dispatchAppData,
  dispatchAppDraft,
  dispatchClearChat,
  dispatchCreateApp,
  dispatchCreateAppNewtab,
  dispatchUpdateApp,
  dispatchSaveCurrentAppDetails,
  dispatchAppToolTest,
  dispatchDeleteApp,
  dispatchValidateDeletion,
  dispatchAppDetails,
  dispatchPublishedAppEditDetails,
  dispatchQueryUrls,
  dispatchUpdateQueryUrlWithRequest,
  dispatchPublishApp,
  dispatchAppHistory,
  dispatchAppVersions,
  dispatchGetRunStatus,
  dispatchAppShareToolTest,
  dispatchRunHistory,
  dispatchTags,
  dispatchExportWorkflow,
  dispatchImportWorkflow,
  dispatchAppShareDetails,
  dispatchAppShareLinkGeneration,
  dispatchAppShareLinkValidation,
  dispatchbulkrunStatusApp,
  dispatcVisionMModels,
  dispatchUploadFileUsingLink,
  dispatchUploadFilesInternal,
  dispatchUploadInAppShare,
  dispatchgenerateFileUpload,
  dispatchDownloadBulkrunTemplate,
  dispatchDownloadBulkrunTemplateAiAgent,
  dispatchTerminateBulkrun,
  dispatchenduserapi,
  dispatchExecuteBulkRun,
  dispatchAppApiIntegrate,
  dispatchManagePromptApp,
  dispatchGetPromptTemplateDetails,
  dispatchPromptPublished,
  dispatchPromptDraft,
  dispatchAppDetailsTemplates,
  dispatchVectorDb,
  dispatchEnableDisableUser,
  dispatchListUsers,
  dispatchUpdateUserDetails,
  dispatchCreateUser,
  dispatchDeleteUser,
  dispatchGetUserDetails,
  dispatchListTenants,
  dispatchCreateTenants,
  dispatchClearUserList,
  dispatchAccessList,
  dispatchWorkspaceAccess,
  dispatchRolesList,
  dispatchDeleteAccess,
  dispatchCreateRole,
  dispatchUpdateRole,
  dispatchDeleteRole,
  dispatchTenantDetails,
  dispatchSetPermissionValues,
  dispatchPackageList,
  dispatchProuctsList,
  dispatchUpdateProduct,
  dispatchCreatePackage,
  dispatchUpdatePackage,
  dispatchUpdateTenants,
  dispatchDeletePackages,
  dispatchDeleteTenants,
  dispatchDisableTenants,
  dispatchupdateUserView,
  dispatchEnableTenants,
  dispatchVoiceModels,
  dispatchModels,
  dispatchIntegrationList,
  dispatchMasterIntegrationList,
  dispatchDeletIntegration,
  dispatchUpdateIntegration,
  dispatchCreateIntegration,
  dispatchListAppForPackages,
  dispatchListAppGeneral,
  dispatchSetAsDefault,
  dispatchFeatureSettings,
  dispatchAutosolveDashboard,
  dispatchHomeDashboardTotal,
  dispatchHomeDashboardAgentAssist,
  dispatchHomeDashboardWorkflow,
  diaptchUpdateFileUploadStatus,
  dispatchUpdateFeatureSettingsStatus,
  dispatchCreateFeatureIntegrationSettings,
  dispatchCreateFolderGroup,
  dispatchSetAsTemplate,
  dispatchTicketDetails,
  dispatchListAutoTags,
  dispatchUpdateTicketType,
  dispatchCompanyInfo,
  dispatchUpdatePersona,
  dispatchGetFeatureAppDetails,
  dispatchGetPackageDetails,
  dispatchUpdateFeatureSettings,
  dispatchGetEndPointUrl,
  dispatchGetTenantGroups,
  dispatchSaveTenantGroups,
  dispatchFileUploadMultiplePaths,
  dispatchCreateFodlerFaqPt,
  dispatchListUserRows,
  dispatchDeleteRowDetails,
  dispatchDeleteFaqPastTicketGroups,
  dispatchGetIntegrationToolsForTenants,
  dispatchGetIntegrationForTools,
  dispatchEmbeddingModelList,
  dispatchImportPastTickets,
  dispatchSubscriptionDetails,
  dispatchUpdateTelemetry,
  dispatchTopIntentsQuery,
  dispatchTopIncreasedIntenetQuery,
  dispatchTopDecreasedIntentQuery,
  dispatchTotalIntentsCountQuery,
  dispatchTicketBasedOnIntent,
  dispatchIntentsGrpahData,
  dispatchIntentsList,
  dispatchTimetoResponse,
  dispatchTimetoResolve,
  dispatchTicketEscallation,
  dispatchFirstContactResolution,
  dispatchCommonTags,
  dispatchCurrentModule,
  dispatchDeleteTicketsFaqPt,
  dispatchCustomerHealthDetails,
  dispatchListAllIntents,
  dispatchTestChatBot,
  dispatchClearChatBotHistory,
  dispatchChatMessageState,
  dispatchFiltervalues,
  dispatchTestChatBotAdithyaBirla,
  dispatchAppInsights,
  dispatchBotDetails,
  dispatchUpdateBot,
  dispatchAutoSolveBot,
  dispatchListWidgets,
  dispatchGetWidgetTypes,
  dispatchCreateWidget,
  dispatchTestWidget,
  dispatchGetMcpTools,
  dispatchClearBotDetails,
  dispatchGetAgentList,
  dispatchGetAgentVersions,
  dispatchGetDefaultAgent,
  dispatchSetAgentDefault,
  dispatchPublishAgent,
  dispatchGetInstallationList,
  dispatchUpdateSelectedTools,
  dispatchCreateAgent,
  dispatchCreateBot,
  dispatchUpdateAgent,
  dispatchDeleteAgent,
  dispatchCreateFeatureIntegrationSettingsAutoSolve,
  dispatchGetWidgetDetails,
  dispatchUpdateWidget,
  dispatchDeleteWidget,
  dispatchCloneAutoSolveFeature,
  dispatchGetBotRunHistory,
  dispatchGetBotRunHistoryOfConversation,
  dispatchAgentConversationList,
  dispatchGetAgentConversationDetails,
  dispatchlistScheduler,
  dispatchGenerateCode,
  dispatchBotTestHistory,
  dispatchSaveFeedback,
  dispatchTestApp,
  dispatchClearFileParams,
  dispatchGetAutosolveConversation,
  dispatchUpdateChatdetailsToEmpty,
  dispatchUpdateAgentChatdetailsToEmpty,
  dispatchClearApiWidget,
  dispatchAddCommentsApp,
  dispatchAutoSolveFeedBack,
  dispatchGenerateSASTokenForDownload,
  dispatchClearFileUrl,
  dispatchgetWidgetHistoryDetails,
  dispatchClearWidgetDetails,
  dispatchSetWidgetDetails,
  dispatchDownloadCsvReport,
  dispatchExportAutosolve,
  dispatchImportAutosolve,
  dispatchGenerateSASTokenGeneric,
  dispatchGetUserMappedRoles,
  dispatchClearAgentDetails,
  dispatchClearAgentVersions,
  dispatchUpdateAgentValuesToNull,
  dispatchCreateScheduler,
  dispatchAutoSolveMetaData,
  dispatchValidateChannel,
  dispatchGetMasterData,
  dispatchCloneAutosolveFeature,
  dispatchUpdateFetaureSettings,
  dispatchCreateAutoSolveFeature,
  dispatchGetAgentAssistFilterDetails,
  dispatchNaturalLanguageQueryTranslation,
  dispatchClearAgentList,
  dispatchGetAppId,

  dispatchGetBlockLevelHistory,
  dispatchClearBlockLevelHistory,
  dispatchClearQueryUrl,
  dispatchDownloadCsvReportAgentAssist,
  dispatchClearTotalConversationCount,
  dispatchClearTotalUpvoteCount,
  dispatchClearTotalDownvoteCount,
  dispatchClearTotalUpvoteCountAgentAssist,
  dispatchClearTotalDownvoteCountAgentAssist,
  dispatchClearTotalConversationCountAgentAssist,
  dispatchDeleteScheduler,
  dispatchUpdateScheduler,
  dispatchGetSchedulerHistory,
  dispatchUploadFileConfluence,
  dispatchUploadFileSharePoint,
  dispatchUploadFileSlack,
  dispatchUploadFileSlackChannels,
  dispatchControlRoomDiscoverScreenSaveFilter,
  dispatchGetControlRoomDiscoverScreenSavedFilterNames,
  dispatchGetControlRoomDiscoverScreenSavedFilterDetails,
  dispatchClearBulkRunStatusdynamic,
  dispatchGetControlRoomDiscoverScreenDelete,
  dispatchControlRoomDynamicQuery,
  dispatchGetControlRoomDiscoverScreenGetColumns,
  dispatchUpdateCustomField,
  dispatchGetAgentDetails,
  dispatchGetAutoSolveBlockLevelHistory,
  dispatchGetllmModelDetailsForAutoSolve,
  dispatchFileuploadBulkrun,
  dispatchAutosolverunbatch,
  dispatchTerminateBulkrunforAutoSolve,
  dispatchBotWidgetObjectDetails,
  dispatchGetActiveEnterPriseHubList,
  dispatchGetExHubHistory,
  dispatchUpdateEnterPriseHubList,
  dispatchAutosolveTestHistory,
  dispatchEmailInvite,
  dispatchSupersetLogin,
  dispatchSupersetCsrfToken,
  dispatchGetSupersetChartAPI,
  dispatchGetSupersetChartData,
  dispatchGetSupersetChartID,
  dispatchGetSupersetUrl,
  dispatchSupersetCredentials,
  dispatchGetControlRoomDiscoverScreenGetColumnValuesForFilter,
  dispatchGetSupersetCustomDashboardList,
  dispatchGetRealTimeAudio,
  dispatchGetControlRoomFilterList,
  dispatchGetOrganizationSummaryDriverFilter,
  dispatchCxAutosolveFilter,
  dispatchCxAutosolveDownload,
  dispatchCxAgentAssistFilter,
  dispatchCxAgentAssistDownload,
  dispatchCxAgentAssistCardDetails,
  dispatchcustomerInteractionAutosolveHistory,
  dispatchSingleConversationData,
  dispatchLiveAgentNotifications,
  dispatchLiveAgentEndCall,
  dispatchcustomerInteractionAgentAssistHistory,
  dispatchSingleAgentAssistConversation,
  dispatchCxAutosolveFourCards,
  dispatchCxSeekerCards,
  dispatchCxSeekerHistoryList,
  dispatchCxSeekerDownload,
  dispatchCxSeekerFeedback,
  dispatchCxSeekerConversationDetails,
  dispatchExecuteSeekerPinotQuery,
  dispatchGetAlertsForControlRoom,
  dispatchGetReportsForControlRoom,
  dispatchAddNewReports,
  dispatchGetTrustforteList,
  dispatchGetAgentsList,
  dispatchGetTrustforteMailDocumentData,
  dispatchGetColumnValuesForFilter,
  dispatchGetAlertDetails,
  dispatchCreateAlert,
  dispatchUpdateAlert,
  dispatchDeleteAlert,
  dispatchDeleteReport,
  dispatchGetLatestPublishedApp,
  dispatchUpdateAppDetails,
  dispatchGetDatabaseList,
  dispatchGetDatabaseSchemas,
  dispatchGetDatabaseTables,
  dispatchGetDatabaseColumns,
  dispatchSaveIntegrations,
  dispatchUpdateDatabaseBlock,
  dispatchUpdateScheduleStatus,
  dispatchEvalsRunStatus,
  dispatchGetEvalDatasets,
  dispatchGetEvalHistory,
  dispatchRunEvalAgent,
  dispatchRunEvalApp,
  dispatchCreateEvalDataset,
  dispatchDownloadPdfApi,
  dispatchGetTemplateList,
  dispatchFetchTemplateDetails,
  dispatchUploadTemplate,
  dispatchDeleteTemplate,
  dispatchupdateactiveliveagent,
  dispatchremoveactiveliveagent
}
